(() => {
  if (window.__lalaJourneyAnalyticsReady) return;
  window.__lalaJourneyAnalyticsReady = true;
  if (window.dataLayer == null) window.dataLayer = [];

  const eventNames = [
    'mix_entrypoint_clicked', 'mix_builder_viewed', 'mix_package_selected',
    'mix_scoop_added', 'mix_scoop_removed', 'mix_completed', 'mix_render_state',
    'mix_render_asset_error', 'mix_added_to_cart', 'mix_cart_error',
    'mix_cart_refresh_error', 'mix_draft_restored', 'mix_edit_clicked',
    'mix_notify_opened', 'search_submitted',
    'search_results_viewed', 'search_result_clicked',
    'location_canton_selected', 'location_cluster_opened',
    'location_directions_opened', 'club_waitlist_viewed',
    'club_waitlist_submission_attempted', 'club_waitlist_joined'
  ];
  const safeKeys = new Set([
    'source', 'asset', 'package', 'state', 'selectionCount', 'count', 'position',
    'limit', 'grams', 'weight', 'verified', 'ingredients', 'packages',
    'recipeHash', 'recipeId', 'queryLength', 'resultCount', 'resultType', 'canton'
  ]);

  const sanitize = (detail = {}) => {
    const payload = { page: window.location.pathname };
    Object.entries(detail).forEach(([key, value]) => {
      if (!safeKeys.has(key) || Array.isArray(value) || typeof value === 'object') return;
      if (['string', 'number', 'boolean'].includes(typeof value)) payload[key] = value;
    });
    return payload;
  };

  const forward = (name, detail = {}) => {
    const payload = sanitize(detail);
    if (Array.isArray(window.dataLayer)) {
      const dataLayerPayload = { event: `lala_${name}`, lala_page: payload.page };
      Object.entries(payload).forEach(([key, value]) => {
        if (key !== 'page') dataLayerPayload[`lala_${key}`] = value;
      });
      window.dataLayer.push(dataLayerPayload);
    }
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish === 'function') {
      try {
        const result = publish.call(window.Shopify.analytics, `lala_${name}`, payload);
        if (result?.catch) result.catch(() => {});
      } catch (_) {
        // Shopify analytics can be unavailable before consent/runtime initialization.
      }
    }
  };

  eventNames.forEach((name) => {
    window.addEventListener(`lala:${name}`, (event) => forward(name, event.detail));
  });

  if (Array.isArray(window.__lalaJourneyQueue)) {
    window.__lalaJourneyQueue.splice(0).forEach((queued) => {
      if (!queued || !eventNames.includes(queued.name)) return;
      forward(queued.name, queued.detail);
    });
  }

  const entrypointSource = (link) => {
    if (link.dataset.lalaEntrypoint) return link.dataset.lalaEntrypoint;
    if (link.closest('.lala-create-mix-callout')) return 'home';
    if (link.closest('.product-actions')) return 'product';
    if (link.closest('header, .shopify-section-header')) return 'navigation';
    return 'other';
  };

  const resultsSelector = '[data-js-search-results], .lala-search-page__results';
  const itemSelector = '[data-js-search-item], .lala-search-page__results [data-js-product-item], .lala-search-page__results .product-item';
  const locationRootSelector = '[data-lala-retail-map]';

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const locationRoot = event.target.closest(locationRootSelector);
    if (locationRoot) {
      const cantonButton = event.target.closest('[data-map-canton]');
      if (cantonButton) {
        window.dispatchEvent(new CustomEvent('lala:location_canton_selected', {
          detail: { canton: cantonButton.dataset.mapCanton || '', source: 'desktop' }
        }));
      }

      const cluster = event.target.closest('[data-map-cluster]');
      if (cluster) {
        const count = locationRoot.querySelectorAll('[data-map-cluster-popover] [data-location-link]').length;
        window.dispatchEvent(new CustomEvent('lala:location_cluster_opened', {
          detail: { canton: 'be', count }
        }));
      }

      const directionsLink = event.target.closest('a[data-location-link]');
      if (directionsLink) {
        window.dispatchEvent(new CustomEvent('lala:location_directions_opened', {
          detail: {
            canton: directionsLink.dataset.mapCantonKey || '',
            source: directionsLink.closest('[data-map-cluster-popover]') ? 'cluster' : 'map'
          }
        }));
      }
    }

    const link = event.target.closest('a[href]');
    if (link) {
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && /\/pages\/(dein-mix|entdeckerbox|lala-mix|discovery-box|box-decouverte|box-scoperta)\/?$/.test(url.pathname)) {
        window.dispatchEvent(new CustomEvent('lala:mix_entrypoint_clicked', {
          detail: { source: entrypointSource(link) }
        }));
      }
    }
    const result = event.target.closest(itemSelector);
    if (result) {
      const siblings = result.parentElement ? Array.from(result.parentElement.querySelectorAll(itemSelector)) : [];
      window.dispatchEvent(new CustomEvent('lala:search_result_clicked', {
        detail: { position: Math.max(siblings.indexOf(result), 0) + 1, resultType: result.dataset.type || 'product' }
      }));
    }
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target instanceof HTMLSelectElement ? event.target : null;
    if (!select?.matches(`${locationRootSelector} [data-map-select]`)) return;
    window.dispatchEvent(new CustomEvent('lala:location_canton_selected', {
      detail: { canton: select.value || '', source: 'mobile' }
    }));
  }, true);

  const formQueryLength = (form) => {
    const input = form?.querySelector('input[type="search"], [data-js-search-input]');
    return Math.min(String(input?.value || '').trim().length, 120);
  };
  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (form?.id === 'LalaClubWaitlistForm') {
      window.dispatchEvent(new CustomEvent('lala:club_waitlist_submission_attempted', {
        detail: { source: 'lala_club_page' }
      }));
      return;
    }
    if (!form || !form.action || !new URL(form.action, window.location.href).pathname.endsWith('/search')) return;
    window.dispatchEvent(new CustomEvent('lala:search_submitted', {
      detail: { queryLength: formQueryLength(form), source: form.closest('search-form') ? 'predictive' : 'search' }
    }));
  }, true);

  const viewedSignatures = new WeakMap();
  const observedHolders = new WeakSet();
  const emitResultsViewed = (holder) => {
    if (!(holder instanceof Element)) return;
    const results = holder.querySelectorAll(itemSelector);
    if (!results.length) return;
    const searchForm = holder.closest('search-form');
    const input = searchForm?.querySelector('input[type="search"], [data-js-search-input]')
      || holder.closest('.lala-search-page')?.querySelector('.search-page-form input[type="search"], [data-js-search-input]');
    const query = String(input?.value || '').trim();
    const signature = `${query}\u0000${results.length}`;
    if (viewedSignatures.get(holder) === signature) return;
    viewedSignatures.set(holder, signature);
    window.dispatchEvent(new CustomEvent('lala:search_results_viewed', {
      detail: {
        queryLength: Math.min(query.length, 120),
        resultCount: results.length,
        resultType: 'product',
        source: searchForm ? 'predictive' : 'search'
      }
    }));
  };
  const observeHolder = (holder) => {
    if (!(holder instanceof Element) || observedHolders.has(holder)) return;
    observedHolders.add(holder);
    const observer = new MutationObserver(() => emitResultsViewed(holder));
    observer.observe(holder, { childList: true, subtree: true, characterData: true });
    emitResultsViewed(holder);
  };
  const discoverHolders = (root) => {
    if (!(root instanceof Element) && !(root instanceof Document)) return;
    if (root instanceof Element && root.matches(resultsSelector)) observeHolder(root);
    root.querySelectorAll(resultsSelector).forEach(observeHolder);
  };
  const discoveryObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes, target }) => {
      addedNodes.forEach((node) => discoverHolders(node));
      if (target instanceof Element) {
        const holder = target.closest(resultsSelector);
        if (holder) emitResultsViewed(holder);
      }
    });
  });
  discoverHolders(document);
  discoveryObserver.observe(document.documentElement, { childList: true, subtree: true });

  const clubWaitlist = document.querySelector('[data-lala-club-waitlist]');
  if (clubWaitlist) {
    window.dispatchEvent(new CustomEvent('lala:club_waitlist_viewed', {
      detail: { source: 'lala_club_page' }
    }));
    if (clubWaitlist.querySelector('[data-lala-club-waitlist-success]')) {
      window.dispatchEvent(new CustomEvent('lala:club_waitlist_joined', {
        detail: { source: 'lala_club_page' }
      }));
    }
  }
})();
